import type { VideoPresentation } from '../../../renderer/src/video-presentation';

/** Keeps the preview URL current without navigating its persistent composition. */
export function compositionPresentationUrlWriter() {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return {
    update(presentation: VideoPresentation) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('presentation', JSON.stringify(presentation));
        window.history.replaceState(window.history.state, '', url);
      }, 250);
    },
    dispose() { clearTimeout(timer); },
  };
}
